import useFetch from '@/composables/useFetch';
import { PaginationResponse } from '@/model/api';
import { JAV, JAVOption, JAVPaginationRequest } from '@/model/jav';
import { HttpStatusCode } from 'axios';

export async function getJAVPagination(query: JAVPaginationRequest) {
	const res = await useFetch<PaginationResponse<JAV>>({
		method: 'GET',
		url: '/jav',
		params: query,
		signalUUID: `GET_JAV_PAGINATION`
	});
	return res.data;
}

export async function getJAV(javUUID: string) {
	const res = await useFetch<JAV>({
		method: 'GET',
		url: '/jav/' + javUUID
	});
	return res.data;
}

export async function createJAV(data: JAV) {
	return await useFetch({
		method: 'POST',
		url: '/jav',
		data
	});
}

export async function updateJAV(data: JAV) {
	return await useFetch({
		method: 'PATCH',
		url: '/jav/' + data.javUUID,
		data
	});
}

export async function favoriteJAV(javUUID: string, isFavorite: boolean) {
	return await useFetch({
		method: 'PATCH',
		url: `/jav/${javUUID}/favorite`,
		data: { isFavorite }
	});
}

export async function deleteJAV(javUUID: string) {
	return await useFetch({
		method: 'DELETE',
		url: '/jav/' + javUUID
	});
}

export async function getJAVOptions(): Promise<JAVOption> {
	const res = await useFetch<JAVOption>({
		method: 'GET',
		url: '/jav/option'
	});
	if (res.status === HttpStatusCode.Ok && res.data) {
		return res.data;
	}
	return {
		actresses: [],
		genres: []
	};
}
